"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _fsm = require("@xstate/fsm");

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createFileUploaderMachine = function createFileUploaderMachine(context) {
  var defaultContext = _objectSpread(_objectSpread({}, _constants.INITIAL_CONTEXT), context);

  return (0, _fsm.createMachine)({
    id: 'file-uploader',
    initial: 'default',
    context: _objectSpread(_objectSpread({}, _constants.INITIAL_CONTEXT), context),
    states: {
      "default": {
        on: {
          UPLOAD: {
            target: 'uploading',
            actions: ['updateContext']
          },
          DISABLE: {
            target: 'disabled',
            actions: ['updateContext']
          },
          REJECT: {
            target: 'error',
            actions: ['updateContext']
          }
        }
      },
      uploading: {
        on: {
          RESOLVE: {
            target: 'success',
            actions: ['updateContext']
          },
          REJECT: {
            target: 'error',
            actions: ['updateContext']
          }
        }
      },
      success: {
        on: {
          RESET: {
            target: 'default',
            actions: ['reset']
          }
        }
      },
      error: {
        on: {
          UPLOAD: {
            target: 'uploading',
            actions: ['updateContext']
          }
        }
      },
      disabled: {
        on: {
          ACTIVATE: 'default',
          UPDATE: {
            target: 'disabled',
            actions: ['updateContext']
          }
        }
      }
    }
  }, {
    actions: {
      reset: (0, _fsm.assign)(function (ctx, env) {
        return _objectSpread(_objectSpread({}, defaultContext), env);
      }),
      updateContext: (0, _fsm.assign)(function (ctx, env) {
        return _objectSpread({}, env);
      })
    }
  });
};

var _default = createFileUploaderMachine;
exports["default"] = _default;